import {MixtureNoteLinkedGroupAdapter} from 'notebook/integrations/registry/MixtureNoteLinkedGroupAdapter';
import {
  NoteLinkedGroupKind,
  UnknownNoteLinkedGroupAdapter,
} from 'notebook/notes/groups/NoteLinkedGroupConstants';
import lazyInit from 'util/lazyInit';

export const getNoteLinkedGroupAdapters: () => {
  [index in NoteLinkedGroupKind]: UnknownNoteLinkedGroupAdapter;
} = lazyInit(() => ({
  [NoteLinkedGroupKind.MIXTURE_GROUP]: new MixtureNoteLinkedGroupAdapter(NoteLinkedGroupKind.MIXTURE_GROUP),
}));

export function isKnownNoteLinkedGroupAdapter(kind: string): boolean {
  return Object.keys(getNoteLinkedGroupAdapters()).includes(kind);
}

export function getMixtureGroupAdapter(): MixtureNoteLinkedGroupAdapter {
  return getNoteLinkedGroupAdapters()[NoteLinkedGroupKind.MIXTURE_GROUP] as MixtureNoteLinkedGroupAdapter;
}
